module.exports = __webpack_public_path__ + "assets/badge-module-1.9d7ab4e649fde561afbb12b826dfc0ae.svg";